import Accordion from '@admin-components/Accordion';
import AccordionSummary from '@admin-components/AccordionSummary';
import { useFetchProjectsForUserQuery } from '@admin-services';
import { AccordionDetails, Box, Typography } from '@mui/material';
import { useCallback, useState } from 'react';
import ProjectsTable from './ProjectsTable';
import TitoTable from './TitoTable';

export interface ProjectsProps {
  userEmail: string;
}
const Projects = ({ userEmail }: ProjectsProps) => {
  const { data } = useFetchProjectsForUserQuery({ user_email: userEmail }, { skip: !userEmail });
  const [flycasterExpanded, setFlycasterExpanded] = useState<boolean>(true);
  const toggleFlycasterExpanded = useCallback(() => {
    setFlycasterExpanded((prev) => !prev);
  }, []);
  const [titoExpanded, setTitoExpanded] = useState<boolean>(false);
  const toggleTitoExpanded = useCallback(() => {
    setTitoExpanded((prev) => !prev);
  }, []);

  return (
    <Box sx={{ display: 'flex', flex: 1, height: '100%', overflowY: 'auto', flexDirection: 'column' }}>
      <Accordion expanded={flycasterExpanded} onChange={toggleFlycasterExpanded}>
        <AccordionSummary>
          <Typography component="span" variant="subtitle1">
            AdTech
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ProjectsTable data={data?.campaigns} />
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={titoExpanded} onChange={toggleTitoExpanded}>
        <AccordionSummary>
          <Typography component="span" variant="subtitle1">
            Tito
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TitoTable data={data?.tacklebox} />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
export default Projects;
